module.exports = __webpack_public_path__ + "img/horizontal_7_4_0.5984989a.png";